import React from 'react'
class queryStepBar extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
     let {datas,curstep}=this.props
      return (
        <div className="stepBox">
        {datas.map((item,index)=>{
            return(
             <div className={`stepBar stepBar${index} ${curstep-index<0?null:'active'}`} key={index}>   
                <div className="step_text"><span className={`left ${index!==0?'span_trager':null}`}></span>{item}</div>
                <span className={`right ${index!==datas.length-1?null:'span_trager'}`}></span>
             </div>
            )
        })}

        </div>

      );
    }
}

export default queryStepBar